import React from 'react';

import { StorageOfUniqueServices } from '@qality/common-service';

import ImagePosition from './FileUploadIcon.styled';

const FileUploadIcon = () => {
  return (
    <ImagePosition>
      <img
        alt='File Upload Icon'
        src={StorageOfUniqueServices.get('URLService').getFileUploadIconPath()}
      />
    </ImagePosition>
  );
};

export default FileUploadIcon;
